import {
  CV_SELECTED_CASEFORM_FETCHITEM_LOAD,
  CV_SELECTED_CASEFORM_FETCHITEM_SUCCEED,
  CV_SELECTED_CASEFORM_FETCHITEM_FAIL,
  CV_SELECTED_CASEFORM_EDITFORM_CHANGE,
  CV_SELECTED_CASEFORM_ENTER_RESET,
  CV_SELECTED_CASEFORM_CREATEITEM_LOAD,
  CV_SELECTED_CASEFORM_CREATEITEM_SUCCEED,
  CV_SELECTED_CASEFORM_CREATEITEM_FAIL,
  CV_SELECTED_CASEFORM_EDITITEM_LOAD,
  CV_SELECTED_CASEFORM_EDITITEM_SUCCEED,
  CV_SELECTED_CASEFORM_EDITITEM_FAIL,
  CV_SELECTED_CASEFORM_DELETEITEM_LOAD,
  CV_SELECTED_CASEFORM_DELETEITEM_SUCCEED,
  CV_SELECTED_CASEFORM_DELETEITEM_FAIL,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case CV_SELECTED_CASEFORM_FETCHITEM_LOAD:
      return { ...state, isFetchItemLoading: true, fetchItemError: null }
    case CV_SELECTED_CASEFORM_FETCHITEM_SUCCEED:
      return { ...state, isFetchItemLoading: false, item: action.item }
    case CV_SELECTED_CASEFORM_FETCHITEM_FAIL:
      return { ...state, isFetchItemLoading: false, fetchItemError: action.fetchItemError }
    case CV_SELECTED_CASEFORM_ENTER_RESET:
      return {
        pa: action.pa,
      }
    case CV_SELECTED_CASEFORM_EDITFORM_CHANGE:
      return { ...state, formFieldValues: { ...state.formFieldValues, ...action.field } }
    case CV_SELECTED_CASEFORM_CREATEITEM_LOAD:
      return {
        ...state,
        isCreateItemLoading: true,
        isCreateItemSuccess: false,
        createItemError: null,
      }
    case CV_SELECTED_CASEFORM_CREATEITEM_SUCCEED:
      return { ...state, isCreateItemLoading: false, isCreateItemSuccess: true }
    case CV_SELECTED_CASEFORM_CREATEITEM_FAIL:
      return { ...state, isCreateItemLoading: false, createItemError: action.createItemError }
    case CV_SELECTED_CASEFORM_EDITITEM_LOAD:
      return {
        ...state,
        isEditItemLoading: true,
        isEditItemSuccess: false,
        editItemError: null,
      }
    case CV_SELECTED_CASEFORM_EDITITEM_SUCCEED:
      return { ...state, isEditItemLoading: false, isEditItemSuccess: true }
    case CV_SELECTED_CASEFORM_EDITITEM_FAIL:
      return { ...state, isEditItemLoading: false, editItemError: action.editItemError }
    case CV_SELECTED_CASEFORM_DELETEITEM_LOAD:
      return {
        ...state,
        isDeleteItemLoading: true,
        isDeleteItemSuccess: false,
        deleteItemError: null,
      }
    case CV_SELECTED_CASEFORM_DELETEITEM_SUCCEED:
      return { ...state, isDeleteItemLoading: false, isDeleteItemSuccess: true }
    case CV_SELECTED_CASEFORM_DELETEITEM_FAIL:
      return { ...state, isDeleteItemLoading: false, deleteItemError: action.deleteItemError }
    default:
      return state
  }
}
